(() => {
  const FEE_VARIANT_ID = 45083233190083;

  const PROPERTY_NAME = "properties[Custom_name_with_fee]";

  const TOGGLE_LABEL = "Add custom a name (+$10)";
  const TOGGLE_HELP =
    "Enable to personalize your card. Disabling removes the fee and clears the message.";

  let bypassSubmitOnce = false;
  let syncing = false;

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }

  async function addFee() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [
          {
            id: FEE_VARIANT_ID,
            quantity: 1,
            properties: { _special_instructions_fee: "1" },
          },
        ],
      }),
    });
  }

  async function changeByKey(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: qty }),
    });
  }

  function findFeeItem(cart) {
    return cart.items.find(
      (it) => Number(it.variant_id) === Number(FEE_VARIANT_ID)
    );
  }

  async function ensureFee(desiredOn) {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();
      const feeItem = findFeeItem(cart);

      if (desiredOn) {
        if (!feeItem) {
          await addFee();
        } else if (feeItem.quantity !== 1) {
          await changeByKey(feeItem.key, 1);
        }
      } else {
        if (feeItem) {
          await changeByKey(feeItem.key, 0);
        }
      }

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch (e) {
      console.error("[Special instructions fee] ensureFee error:", e);
    } finally {
      syncing = false;
    }
  }

  function buildToggleUI() {
    const wrap = document.createElement("div");
    wrap.className = "special-instructions-toggle";
    wrap.setAttribute("data-special-instructions-toggle", "1");
    wrap.style.margin = "12px 0";
    wrap.style.display = "flex";
    wrap.style.flexDirection = "column";
    wrap.style.gap = "6px";

    const row = document.createElement("label");
    row.style.display = "flex";
    row.style.alignItems = "center";
    row.style.gap = "10px";
    row.style.cursor = "pointer";
    row.style.userSelect = "none";

    const input = document.createElement("input");
    input.type = "checkbox";
    input.id = "SpecialInstructionsToggle";
    input.style.width = "18px";
    input.style.height = "18px";

    const text = document.createElement("span");
    text.textContent = TOGGLE_LABEL;

    row.appendChild(input);
    row.appendChild(text);

    const help = document.createElement("small");
    help.textContent = TOGGLE_HELP;
    help.style.opacity = "0.75";
    help.style.lineHeight = "1.3";

    wrap.appendChild(row);
    wrap.appendChild(help);

    return { wrap, input };
  }

  // ✅ IMPORTANTE: si el tema duplica el input (sticky ATC), toma el visible
  function getPropertyField() {
    const nodes = Array.from(
      document.querySelectorAll(
        `textarea[name="${PROPERTY_NAME}"], input[name="${PROPERTY_NAME}"]`
      )
    );
    return nodes.find((n) => n.offsetParent !== null) || nodes[0] || null;
  }

  function showEl(el) {
    if (!el) return;
    el.style.display = "";
  }

  function hideEl(el) {
    if (!el) return;
    el.style.display = "none";
  }

  function interceptProductFormSubmit(propertyField, toggleInput) {
    const form = propertyField.closest("form");
    if (!form) return;

    const waitForSync = async () => {
      const started = Date.now();
      while (syncing && Date.now() - started < 2000) {
        await new Promise((r) => setTimeout(r, 50));
      }
    };

    form.addEventListener("submit", async (e) => {
      if (bypassSubmitOnce) return;

      const submitter = e.submitter;
      const isAddToCart =
        submitter &&
        submitter.type === "submit" &&
        (
          submitter.name === "add" ||
          submitter.name === "add-to-cart" ||
          submitter.getAttribute("data-action") === "add-to-cart" ||
          submitter.id?.toLowerCase().includes("add") ||
          submitter.className?.toLowerCase().includes("add")
        );

      if (!isAddToCart) return;

      e.preventDefault();

      const text = String(propertyField.value || "").trim();
      const hasText = text.length >= 1;

      // ✅ Si está marcado pero no escribió nada -> bloquear + NO cobrar
      if (toggleInput.checked && !hasText) {
        await waitForSync();
        await ensureFee(false);
        alert("Please type at least 1 character for the ribbon name or uncheck the option.");
        return;
      }

      const desiredOn = !!toggleInput.checked && hasText;

      // ✅ Evita carrera si justo se estaba agregando/quitando fee por el input event
      await waitForSync();
      await ensureFee(desiredOn);

      bypassSubmitOnce = true;
      form.submit();
    });
  }

  function init() {
    if (document.getElementById("SpecialInstructionsToggle")) return;

    const propertyField = getPropertyField();
    if (!propertyField) return;

    const blockWrap =
      propertyField.closest(".custom-property") ||
      propertyField.closest(".product-custom-property") ||
      propertyField.parentElement;

    const { wrap: toggleWrap, input: toggleInput } = buildToggleUI();

    if (blockWrap && blockWrap.parentElement) {
      blockWrap.parentElement.insertBefore(toggleWrap, blockWrap);
    } else {
      propertyField.insertAdjacentElement("beforebegin", toggleWrap);
    }

    const initialHasText = String(propertyField.value || "").trim().length >= 1;
    toggleInput.checked = initialHasText;

    if (toggleInput.checked) showEl(blockWrap);
    else hideEl(blockWrap);

    // ✅ Al activar: mostrar campo, NO cobrar todavía (hasta que escriba)
    toggleInput.addEventListener("change", async () => {
      if (toggleInput.checked) {
        showEl(blockWrap);
        await ensureFee(false);
      } else {
        hideEl(blockWrap);
        propertyField.value = "";
        propertyField.dispatchEvent(new Event("input", { bubbles: true }));
        await ensureFee(false);
      }
    });

    // ✅ Cobrar solo si hay texto (>= 1) y toggle ON
    propertyField.addEventListener("input", async () => {
      const hasText = String(propertyField.value || "").trim().length >= 1;

      if (!toggleInput.checked) {
        await ensureFee(false);
        return;
      }
      await ensureFee(hasText);
    });

    interceptProductFormSubmit(propertyField, toggleInput);
  }

  window.addEventListener("DOMContentLoaded", () => {
    init();
    setTimeout(init, 300);
    setTimeout(init, 1200);
  });
})();